import * as types from 'src/state/ducks/orderItem/types';
import { OrderItemEntity } from 'src/firebase/db/OrderItems';
import { APISuccessfulResponse, APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';
import { ValidationResponse } from 'src/firebase/db/ValidationManager';

export type Actions =
  | GetOrderItems
  | SuccessGetOrderItems
  | FailGetOrderItems
  | GetDayOrderItems
  | SuccessGetDayOrderItems
  | FailGetDayOrderItems
  | EditOrderItem
  | ValidateOrderItem
  | SuccessValidateOrderItem
  | FailValidateOrderItem
  | CreateOrderItem
  | SuccessCreateOrderItem
  | FailCreateOrderItem
  | InitOrderItem;

/**
 * Get
 */
interface GetOrderItems {
  type: typeof types.GET_ORDER_ITEMS;
  payload: {
    shopId: string;
  };
}
export const getOrderItems = (payload: GetOrderItems['payload']) => ({
  type: types.GET_ORDER_ITEMS,
  payload,
});

interface SuccessGetOrderItems {
  type: typeof types.SUCCESS_GET_ORDER_ITEMS;
  payload: APISuccessfulResponse<OrderItemEntity[]>;
}
export const successGetOrderItems = (payload: SuccessGetOrderItems['payload']) => ({
  type: types.SUCCESS_GET_ORDER_ITEMS,
  payload,
});

interface FailGetOrderItems {
  type: typeof types.FAIL_GET_ORDER_ITEMS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetOrderItems = (payload: FailGetOrderItems['payload']) => ({
  type: types.FAIL_GET_ORDER_ITEMS,
  payload,
});

/**
 * ReEdit
 */
interface EditOrderItem {
  type: typeof types.EDIT_ORDER_ITEM;
  payload: OrderItemEntity;
}
export const editOrder = (payload: ValidateOrderItem['payload']) => ({
  type: types.EDIT_ORDER_ITEM,
  payload,
});

/**
 * Validate
 */
interface ValidateOrderItem {
  type: typeof types.VALIDATE_ORDER_ITEM;
  payload: OrderItemEntity;
}
export const validateOrder = (payload: ValidateOrderItem['payload']) => ({
  type: types.VALIDATE_ORDER_ITEM,
  payload,
});

interface SuccessValidateOrderItem {
  type: typeof types.SUCCESS_VALIDATE_ORDER_ITEM;
  payload: APISuccessfulResponse<OrderItemEntity>;
}
export const successValidateOrderItem = (payload: SuccessValidateOrderItem['payload']) => ({
  type: types.SUCCESS_VALIDATE_ORDER_ITEM,
  payload,
});

interface FailValidateOrderItem {
  type: typeof types.FAIL_VALIDATE_ORDER_ITEM;
  payload: ValidationResponse | APIFailedResponse;
}
export const failValidateOrderItem = (payload: FailValidateOrderItem['payload']) => ({
  type: types.FAIL_VALIDATE_ORDER_ITEM,
  payload,
});

/**
 * Create
 */
interface CreateOrderItem {
  type: typeof types.CREATE_ORDER_ITEM;
  payload: string;
}
export const createOrder = (payload: CreateOrderItem['payload']) => ({
  type: types.CREATE_ORDER_ITEM,
  payload,
});

interface SuccessCreateOrderItem {
  type: typeof types.SUCCESS_CREATE_ORDER_ITEM;
  payload: APISuccessfulResponse<OrderItemEntity>;
}
export const successCreateOrderItem = (payload: SuccessCreateOrderItem['payload']) => ({
  type: types.SUCCESS_CREATE_ORDER_ITEM,
  payload,
});

interface FailCreateOrderItem {
  type: typeof types.FAIL_CREATE_ORDER_ITEM;
  payload: ValidationResponse | APIFailedResponse;
}
export const failCreateOrderItem = (payload: FailCreateOrderItem['payload']) => ({
  type: types.FAIL_CREATE_ORDER_ITEM,
  payload,
});

interface GetDayOrderItems {
  type: typeof types.GET_DAY_ORDER_ITEMS;
  payload: {
    shopId: string;
    startDate: Date;
    endDate: Date;
  };
}
export const getDayOrderItems = (payload: GetDayOrderItems['payload']) => ({
  type: types.GET_DAY_ORDER_ITEMS,
  payload,
});

interface SuccessGetDayOrderItems {
  type: typeof types.SUCCESS_GET_DAY_ORDER_ITEMS;
  payload: APISuccessfulResponse<OrderItemEntity[]>;
}
export const successGetDayOrderItems = (payload: SuccessGetDayOrderItems['payload']) => ({
  type: types.SUCCESS_GET_DAY_ORDER_ITEMS,
  payload,
});

interface FailGetDayOrderItems {
  type: typeof types.FAIL_GET_DAY_ORDER_ITEMS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetDayOrderItems = (payload: FailGetDayOrderItems['payload']) => ({
  type: types.FAIL_GET_DAY_ORDER_ITEMS,
  payload,
});

/**
 * Init state
 */
interface InitOrderItem {
  type: typeof types.INIT_ORDER_ITEM;
}
export const initOrderItem = () => ({
  type: types.INIT_ORDER_ITEM,
});
